import React, { useContext, useState } from "react";
import AppContext from "../../Context/AppContext";
import { ChatControlContainer, MessageBox, Button } from "../style";

const ChatControl = () => {
  const { chatList, websocket, turn, setChatList } = useContext(AppContext);
  const [message, setMessage] = useState("");

  const sendMessage = () => {
    if (websocket.readyState === websocket.OPEN) {
      let jsonMessage = JSON.stringify({ command: "msg", arg: message });
      websocket.send(jsonMessage);
      setChatList([...chatList, message]);
      setMessage("");
    }
  };

  return (
    <ChatControlContainer>
      {turn === "night" ? (
        <>
          <MessageBox placeholder="Sleep" name="message" disabled />
          <Button onClick={sendMessage} disabled={true}>
            Send
          </Button>
        </>
      ) : (
        <>
          <MessageBox
            placeholder="Enter message"
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <Button onClick={sendMessage}>Send</Button>
        </>
      )}
    </ChatControlContainer>
  );
};

export default ChatControl;
